import { ServerResponse, WithAuditDetails } from 'data/types';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from 'data/root.reducers';
import { Action } from 'redux';
import { extractErrorMessage } from 'utils';
import { AxiosError } from 'axios';
import i18n from 'i18n';
import { showSuccessMessage, showError } from 'shared/toaster';
import * as api from './certStatus.api';
import {
  GET_CERT_STATUS_LIST,
  GetCertStatusListAction,
  CreateCertStatusAction,
  CertStatus,
  CREATE_CERT_STATUS,
  ActivateCertStatusThunkAction,
  ACTIVATE_CERT_STATUS,
  DeleteCertStatusThunkAction,
  DELETE_CERT_STATUS,
  CreateCertStatusThunkAction
} from './certStatus.types';

export function getAllCertStatus(
  deliveryFunctionId: string
): GetCertStatusListAction {
  return {
    type: GET_CERT_STATUS_LIST,
    payload: api.getAllCertStatus(deliveryFunctionId)
  };
}

export function createCertStatus(
  deliveryFunctionId: string,
  body: WithAuditDetails<CertStatus>
): CreateCertStatusAction {
  return {
    type: CREATE_CERT_STATUS,
    payload: api.createCertStatus(deliveryFunctionId, body)
  };
}

export function createCertStatusAndGetAll(
  deliveryFunctionId: string,
  body: WithAuditDetails<CertStatus>
): CreateCertStatusThunkAction {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    try {
      await dispatch({
        type: CREATE_CERT_STATUS,
        payload: api.createCertStatus(deliveryFunctionId, body)
      });

      await dispatch({
        type: GET_CERT_STATUS_LIST,
        payload: api.getAllCertStatus(deliveryFunctionId)
      });

      showSuccessMessage(i18n.t('certStatus.create.success'), 5000);
    } catch (e) {
      const errorMessage = extractErrorMessage(e as AxiosError<ServerResponse<void>>);
      showError(i18n.t('certStatus.create.failed', { error: errorMessage }));
    }
  };
}

export function activateCertStatus(
  deliveryFunctionId: string,
  body: WithAuditDetails<CertStatus>
): ActivateCertStatusThunkAction {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    if (body?.data) {
      body.data.ACTION = 'ACTIVATE';
    }
    try {
      await dispatch({
        type: ACTIVATE_CERT_STATUS,
        payload: api.updateCertStatus(deliveryFunctionId, body)
      });

      await dispatch({
        type: GET_CERT_STATUS_LIST,
        payload: api.getAllCertStatus(deliveryFunctionId)
      });

      showSuccessMessage(i18n.t('certStatus.activate.success', {}), 5000);

    } catch (e) {
      const errorMessage = extractErrorMessage(e as AxiosError<ServerResponse<void>>);
      showError(i18n.t('certStatus.activate.failed', { error: errorMessage }));
    }
  };
}

export function deleteCertStatus(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<CertStatus>
): DeleteCertStatusThunkAction {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    try {
      await dispatch({
        type: DELETE_CERT_STATUS,
        payload: api.deleteCertStatus(deliveryFunctionId, id, body)
      });

      await dispatch({
        type: GET_CERT_STATUS_LIST,
        payload: api.getAllCertStatus(deliveryFunctionId)
      });

      showSuccessMessage(i18n.t('certStatus.delete.success', {}), 5000);

    } catch (e) {
      const errorMessage = extractErrorMessage(e as AxiosError<ServerResponse<void>>);
      showError(i18n.t('certStatus.delete.failed', { error: errorMessage }));
    }
  };
}

// export function activateCertStatus(deliveryFunctionId: string, body: WithAuditDetails<CertStatus>) {
//   if (body?.data) {
//     body.data.ACTION = 'ACTIVATE';
//   }
//   return {
//     type: CREATE_CERT_STATUS,
//     payload: api.updateCertStatus(deliveryFunctionId, body)
//   };
// }

// export function deleteCertStatus(deliveryFunctionId: string, body: WithAuditDetails<CertStatus>) {
//   if (body?.data) {
//     body.data.ACTION = 'NONE';
//   }
//   return {
//     type: CREATE_CERT_STATUS,
//     payload: api.deleteCertStatus(deliveryFunctionId, body.data.id as string, body)
//   };
// }
